import { Cookies } from 'react-cookie';

import { VisitReportsData } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getVisitReportsList = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/visit_report/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as VisitReportsData[];
};
